define('orderSummary/orderSummary',[
    "common/alertMessage",
    "common/formUtils",
    "common/spinner"
],
    function (alertMessage, formUtils, spinner) {

        const orderSummarySelector = ".order-summary";
        const orderSummaryValuesSelector = orderSummarySelector + " .order-summary-values";
        const spinnerSelector = orderSummarySelector + " .values-spinner";

        function refreshSummaryValues(shippingAddress, billingAddress) {
            spinner.show(spinnerSelector);

            var sendData = {
                shippingAddress: shippingAddress,
                billingAddress: billingAddress
            };
            formUtils.useToken(sendData);

            $.ajax({
                type: "POST",
                url: "/customapi/Order/GetOrderSummaryValues",
                dataType: "json",
                data: sendData,
                success: function (data) {
                    if (data.status === "OK") {
                        $(orderSummaryValuesSelector).empty().html(data.content);
                    } else if (data.status === "ERROR") {
                        // Something's not right.
                        // Display the error messages (if any), and stay on the page.
                        $(orderSummaryValuesSelector).empty().html(data.message);
                    }
                },
                error: function (jq, status, errorThrown) {
                    alertMessage.error(status + ": " + errorThrown);
                },
                complete: function () {
                    spinner.hide(spinnerSelector);
                }

            });

        }

        return {
            refreshSummaryValues: refreshSummaryValues
        };
    });

